/* Photo tile sets: no default picks, flashing boxes show what to press, steps go in order; gap fixed at 5 cm, paper fixed to matt; sizes in cm and inch (2026-11-01). */
(function () {
  var picked = {}, req = {}, tm, busy = false;
  function $(id) { return document.getElementById(id); }
  function tabs() { return [].slice.call(document.querySelectorAll('#gts-tabs .tab')); }
  function cur() { var t = tabs(), r = 0; t.forEach(function (x, i) { if (x.getAttribute('aria-selected') === 'true') r = i; }); return r; }
  function tiles() { var t = [].slice.call(document.querySelectorAll('#gts-sets .tile')); return { n: t.length, have: t.filter(function (x) { var p = x.querySelector('.ph'); return p && !p.hasAttribute('data-upl'); }).length }; }
  function rows() { var p = $('gts-pane'); return p ? [].slice.call(p.children).filter(function (r) { return r.classList.contains('row'); }) : []; }
  function kids(r) { return [].slice.call(r.children).filter(function (x) { return /(^|\s)(chip|sw)(\s|$)/.test(x.className); }); }
  function label(b) { return b && b.firstChild ? b.firstChild.textContent.replace('\u2713', '').trim() : 'the previous step'; }
  function inch(cm) { return Math.round(cm / 2.54); }
  function mergeSizes() {
    if (cur() !== 2) return;
    var rs = rows(), r0 = rs[0]; if (!r0) return;
    for (var k = 1; k < rs.length; k++) {
      var c = kids(rs[k]); if (!c.length || !c.every(function (x) { return !/(^|\s)sm(\s|$)/.test(x.className) && (x.querySelector('small') || x.hasAttribute('data-fmt')); })) break;
      c.forEach(function (x) { r0.appendChild(x); });
    }
    r0.classList.add('sizes');
    var all = kids(r0);
    all.forEach(function (x) {
      if (x.hasAttribute('data-fmt')) return;
      var m = /^(\d+)x(\d+)/.exec(x.firstChild ? x.firstChild.textContent.trim() : ''); if (!m) return;
      x.setAttribute('data-fmt', '1'); x.innerHTML = m[1] + 'x' + m[2] + ' cm<small>' + inch(+m[1]) + 'x' + inch(+m[2]) + ' in</small>';
    });
    var two = all.length > 6;
    if (two) { r0.style.display = 'grid'; r0.style.gridTemplateColumns = 'repeat(' + Math.ceil(all.length / 2) + ',minmax(0,1fr))'; r0.style.gap = '4px'; }
    else { r0.style.display = ''; r0.style.gridTemplateColumns = ''; }
  }
  function requiredIdx(step, list) {
    if (step === 0 || step === 2) return list.filter(function (o) { return o.i === 0; }).map(function (o) { return o.i; });
    if (step === 3 || step === 4) return list.map(function (o) { return o.i; });
    if (step === 5) return list.filter(function (o) { return o.i === 0 || o.c.some(function (x) { return /(^|\s)sw(\s|$)/.test(x.className); }); }).map(function (o) { return o.i; });
    return [];
  }
  function complete(step) {
    if (step === 1) { var c = tiles(); return c.n > 0 && c.have === c.n; }
    var r = req[step]; if (!Array.isArray(r)) return false;
    return r.every(function (i) { return picked[step + ':' + i]; });
  }
  function msg(step) {
    if (step === 1) { var c = tiles(); return 'Please add all ' + c.n + ' photos first (' + c.have + ' of ' + c.n + ' added). Tap an empty tile to upload.'; }
    return 'Please choose an option in every flashing box of "' + label(tabs()[step]) + '" first.';
  }
  function lockReason(i) { for (var j = 0; j < i; j++) if (!complete(j)) return msg(j); return ''; }
  function warn(m) {
    var el = $('gts-toast'); if (!el) return;
    el.textContent = m; el.classList.add('err'); el.hidden = false; clearTimeout(tm); tm = setTimeout(function () { el.hidden = true; }, 4200);
  }
  function hideFixed(step) {
    var rs = rows(), pane = $('gts-pane'), h = pane && pane.querySelector(':scope > p.hint');
    if (step === 0) { if (rs[1]) rs[1].style.display = 'none'; if (h && h.textContent.indexOf('Gap') > -1) h.textContent = 'Bigger sets get a bigger discount.'; }
    if (step === 4) {
      if (rs[1]) rs[1].style.display = picked['4:0'] ? '' : 'none';
      if (rs[2]) rs[2].style.display = 'none';
      if (h && /atte|Luster|Matt/.test(h.textContent)) h.style.display = 'none';
    }
  }
  function greyForWhite() {
    var wall = $('gts-wall'), sets = $('gts-sets'), t = sets && !sets.hidden && sets.querySelector('.tile'); if (!wall || !t) return;
    var m = /rgb\((\d+), (\d+), (\d+)/.exec(getComputedStyle(t).borderTopColor || '');
    if (m && +m[1] > 235 && +m[2] > 235 && +m[3] > 230) wall.style.background = '#8E9399';
  }
  function decorate() {
    if (busy) return; busy = true;
    try {
      var step = cur(); mergeSizes(); hideFixed(step); greyForWhite();
      var list = rows().map(function (r, i) { return { r: r, i: i, c: kids(r) }; }).filter(function (o) { return o.c.length && o.r.style.display !== 'none'; });
      if (step !== 1) req[step] = requiredIdx(step, list);
      list.forEach(function (o) {
        var isReq = step !== 1 && req[step].indexOf(o.i) > -1, unp = isReq && !picked[step + ':' + o.i];
        o.c.forEach(function (x) {
          if (unp && x.getAttribute('aria-pressed') === 'true') x.setAttribute('aria-pressed', 'false');
          x.classList.toggle('unp', unp); x.classList.toggle('pick', unp);
        });
      });
      var t = tiles(), need = step === 1 && t.n && t.have < t.n;
      var pane = $('gts-pane');
      if (pane) { var ab = pane.querySelector('.btn:not(.full):not(.alt)'); if (ab) ab.classList.toggle('pick', !!need); }
      [].forEach.call(document.querySelectorAll('#gts-sets .tile .ph'), function (p) { p.classList.toggle('pick', !!(need && p.hasAttribute('data-upl'))); });
      tabs().forEach(function (b, i) {
        b.classList.toggle('lock', !!lockReason(i) && i !== step);
        b.classList.toggle('notdone', b.classList.contains('done') && !complete(i));
        b.classList.toggle('pick', i === step + 1 && complete(step) && !lockReason(i));
      });
      var go = pane && pane.querySelector('.btn.full'); if (go) go.classList.toggle('pick', complete(step));
    } finally { busy = false; }
  }
  function start() {
    var root = $('gts'); if (!root) return;
    $('gts-tabs').addEventListener('click', function (e) {
      var b = e.target.closest && e.target.closest('.tab'); if (!b) return;
      var i = tabs().indexOf(b), r = lockReason(i);
      if (r && i !== cur()) { e.stopPropagation(); e.preventDefault(); warn(r); }
    }, true);
    $('gts-pane').addEventListener('click', function (e) {
      var step = cur(), ch = e.target.closest && e.target.closest('.chip,.sw');
      if (ch) { var i = rows().indexOf(ch.closest('.row')); if (i > -1) { picked[step + ':' + i] = true; if (step === 4 && i === 0) delete picked['4:1']; } return; }
      var b = e.target.closest && e.target.closest('.btn.full'); if (!b) return;
      if (!complete(step)) { e.stopPropagation(); e.preventDefault(); warn(msg(step)); }
    }, true);
    var add = $('gts-add');
    if (add) add.addEventListener('click', function (e) {
      for (var j = 0; j < 6; j++) if (!complete(j)) { e.stopPropagation(); e.preventDefault(); warn(msg(j)); return; }
    }, true);
    decorate(); new MutationObserver(decorate).observe(root, { childList: true, subtree: true });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', start); else start();
})();
